import './Pagination.css';

export default function Pagination({ page, pageCount, setPage, total, pageSize, label = 'Results' }) {
  if (!total) return null;
  return <nav className="pagination" aria-label={`${label} pagination`}>
    <span className="pagination-count" role="status">{(page - 1) * pageSize + 1}–{Math.min(page * pageSize, total)} of {total}</span>
    {pageCount > 1 && <div className="pagination-actions">
      <button type="button" onClick={() => setPage(page - 1)} disabled={page === 1} aria-label={`Previous ${label.toLowerCase()} page`}>Previous</button>
      <span>Page {page} of {pageCount}</span>
      <button type="button" onClick={() => setPage(page + 1)} disabled={page === pageCount} aria-label={`Next ${label.toLowerCase()} page`}>Next</button>
    </div>}
  </nav>;
}
